/* global window */

const Tracking = (function () {
    // TODO: rewrite in ES6

    function Tracking() {
        const tracking = this;
        tracking.trackers = [];
    }

    Tracking.prototype = {
        addTrackingCode (id, test, callback) {
            const tracking = this;

            if (test !== null) {

                const testVal = (function () {

                    let testVal = test;

                    if (testVal === '') {
                        testVal = false;
                    }

                    return !!testVal;

                }());

                // If test doesn't pass, don't add tracking code
                if (!testVal) {
                    return tracking;
                }
            }

            tracking.trackers.push({
                id,
                callback
            });

            return tracking;
        },
        removeTrackingCode (id) {
            const tracking = this;

            let indexOf = -1;

            for (let i = 0; i < tracking.trackers.length; i++) {
                const tracker = tracking.trackers[i];

                if (tracker.id === id) {
                    indexOf = i;
                    break;
                }
            }

            if (indexOf === -1) {
                return tracking;
            }

            tracking.trackers.splice(indexOf, 1);

            return tracking;
        },
        init () {
            const tracking = this;

            for (let i = 0; i < tracking.trackers.length; i++) {
                const tracker = tracking.trackers[i];

                tracker.callback.call(window);
            }
        }
    };

    return Tracking;

}());

export default Tracking;


// WEBPACK FOOTER //
// ./src/js/modules/Tracking.js